export default {
  translation: {
    测试: "测试111",
  },
};
